import { Typography } from 'antd'
import classNames from 'classnames'
import styles from './ListInfoItem.module.scss'

interface IListInfoItemProps {
  name: string
  value: React.ReactNode
  style?: React.CSSProperties
  valueStyle?: React.CSSProperties
  // значение без пробелов (почта) не рвём посередине, а целиком уводим под подпись
  wrapValue?: boolean
}

export const ListInfoItem: React.FC<IListInfoItemProps> = ({
  name,
  value,
  style,
  valueStyle,
  wrapValue = false
}) => {
  return (
    <div className={classNames(styles.wrapper, { [styles.wrapValue]: wrapValue })} style={{ ...style }}>
      <Typography.Text className={styles.name}>{name}:</Typography.Text>
      <Typography.Text className={styles.value} style={valueStyle}>{value}</Typography.Text>
    </div>
  )
}
